import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';
import { Badge, Button } from 'react-bootstrap';
import { formatMoneyShorthand } from 'utils/formatMoney';
import { $view } from 'signals/global.signals';

const getMenuItems = (investor) => {
  const menuItems = [
    {
      label: 'Add To Deal',
      onClick: () => {
        const investorDealIds = investor.deals.map((deal) => deal.id);
        const investorDealOptions = $view.value.dealOptions?.filter((option) => !investorDealIds.includes(option.value));
        $view.update({
          investorDealOptions,
        });
        handleShowModal('founder-investor-add-to-deal', {
          investorName: investor.investorName,
          investorId: investor.investorId,
          recordType: investor.recordType,
        });
      },
    },
  ];

  if (investor.recordType === 'unsynced') {
    menuItems.push({
      label: 'Edit',
      onClick: () => {
        handleShowModal('founder-investor-edit', { ...investor });
      },
    });
  }

  menuItems.push({
    label: 'Delete',
    onClick: () => handleShowModal('founder-investor-delete', { ...investor }),
  });

  return menuItems;
};

const FounderInvestorRow = ({ data }) => data?.map((investor) => ({
  name: investor.investorName,
  email: investor.email,
  investorType: investor.investorType,
  potentialCommitment: `${formatMoneyShorthand(investor.potentialCommitmentMin)} - ${formatMoneyShorthand(investor.potentialCommitmentMax)}`,
  deals: (() => {
    const DealSpans = () => {
      if (!investor.deals || investor.deals.length === 0) return null;
      if (investor.deals.length > 3) {
        return (
          <Button
            variant="transparent"
            className="p-0"
            onClick={() => window.open('/founder/deals', '_blank')}
          >
            <Badge bg="gray-900" className="text-info fw-normal rounded-pill border-dark">
              {investor.deals.length} Deals
            </Badge>
          </Button>
        );
      }
      return (
        <>
          {investor.deals.map((deal, idx) => (
            <Button
              variant="transparent"
              key={deal.id || idx}
              onClick={() => window.open(`/founder/deal/${deal.id}`, '_blank')}
              className="p-0"
            >
              <Badge bg="gray-800" className="text-info fw-normal rounded-pill border-gray-900">
                {deal.name.length > 20 ? `${deal.name.slice(0, 20)}...` : deal.name}
              </Badge>
            </Button>
          ))}
        </>
      );
    };
    return <DealSpans />;
  })(),
  Actions: () => (
    <div className="d-flex align-items-center">
      <ContextMenu
        menuItems={getMenuItems(investor)}
      />
    </div>
  ),
}));

export default FounderInvestorRow;
